module.exports = __webpack_public_path__ + "media/fart-05.a9fca204.mp3";